import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const MultiOfficeRooms3 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="multiOfficeRooms" section="challenges">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="multiOfficeRooms:challenges" noGroupTitle tag="h3" first noPadBottom />
        </div>
    </ServiceSection>
);

export default MultiOfficeRooms3;
